import { Company } from "../../../shared/interfaces/company";
import { BASE_URL } from "../../../shared/utils/variables";
import { getAuthHeaders } from "../../../shared/services/authentication";

const baseURL = BASE_URL;

export const fetchCompaniesService = async (): Promise<Company[]> => {
    try {
        const options = {
            method: 'GET',
            headers: { 
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },
        };

        const response = await fetch(`${baseURL}/companies`, options);
        const data: Company[] = await response.json();

        return data;
    } catch (error) {
        throw error;
    }
}

export const fetchUserCompanyService = async (id: string): Promise<Company> => {
    try {
        const options = {
            method: 'GET',
            headers: { 
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },
        };

        const response = await fetch(`${baseURL}/company/${id}`, options);
        const data: Company = await response.json();

        return data;
    } catch (error) {
        throw error;
    }
}

export const fetchCompanyPlanStatus = async (companyId: string): Promise<any | null> => {
    try {
        const options = {
            method: 'GET',
            headers: { 
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },
        };

        const response = await fetch(`${baseURL}/company/${companyId}/plan-status`, options);
        const data: any = await response.json();

        return data;
    } catch (error) {
        console.error('Erro ao buscar status do plano da empresa:', error);
        return null;
    }
}

export const updateUserCompanyService = async (companyId: string, company: Company): Promise<Company> => {
    try {
        const options = {
            method: 'PUT',
            headers: {
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(company),
        };

        const response = await fetch(`${baseURL}/company/${companyId}`, options);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `Erro HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
}
